'use strict';

class UsuariosService {
  constructor(Storage) {
    'ngInject';
    this.Storage = Storage;
  }

  getRolesResponsable() {
    return ['RESP_DEPARTAMENTAL_UPRE', 'TECNICO_UPRE'];
  }

  esResponsableProyecto() {
    this.usuario = this.Storage.getUser();
    return this.getRolesResponsable().indexOf(this.usuario.rol.nombre) !== -1;
  }

}

export default UsuariosService;



// WEBPACK FOOTER //
// ./src/app/components/admin/usuarios/usuarios.service.js